import {getDocumentoID} from "../utils/functions";
import VueCookies from 'vue-cookies';

const state = {
  haveCuit:undefined,
  ValidBusiness:false,
  ValidZone:false,    
  Institucion:"",
  RazonSocial:"",
  CoindicionIVA:"",
  Nombre:"",
  Apellido:"",
  Cuit:"",
  Email:"",
  DocumentType:"DNI",
  Documento:"",
  Caracter:"",
  CodigoArea:"",
  Celular:"",
  Direccion:
  {
    Feeble_location:false,
    Calle:"",
    Altura:"",
    Piso:"",
    Busqueda:undefined,
    Localidad:undefined,
    MissingFloor:false,
    Latitud:null,
    Longitud:null,
    Zoom:18,
    CodigoArea:"",
    Celular:""
  },
  Rubro:"",
  Subrubro:"",
  Empleados:"",
  UnidadEmpleados:undefined,
  Locales:[],
  Precio:undefined,
  Cupon:undefined,
  AcceptTerms:false,
  Discount: 30,
  PaymentMethod: 'Credit', // Descuento por defecto a todos los ap,
  ItsPromotor:false
};

const EmpresasState = 
{
  namespaced:true,
  state,
  mutations:
  {
    setTerms(state)
    {
      state.AcceptTerms = !state.AcceptTerms;
    },
    setCupon(state,payload)
    {
      state.Cupon = payload;
    },
    setPrecioMain(state,payload)
    {
      state.Precio = payload;
    },
    setLocalPrecio(state,payload)
    {
      const {index,Precio} = payload;
      state.Locales[index].Precio = Precio;
    },
    updateValueState(state, payload)
    {
      state.ValidBusiness = false;
      state[payload.key] = payload.value;
    },
    updateLocation(state, payload)
    {
      state.Direccion[payload.key] = payload.value;
    },
    addSucursal(state,payload)
    {
      state.Locales.push(payload);
    },
    updateSucursal(state,payload)
    {
      const {index,data} = payload;

      state.Locales[index].Celular = data.Celular;
      state.Locales[index].CodigoArea = data.CodigoArea;
      state.Locales[index].Direccion = data.Direccion;
      state.Locales[index].Empleados = data.Empleados;
      state.Locales[index].Precio = data.Precio;
      state.Locales[index].Rubro = data.Rubro;
      state.Locales[index].Subrubro = data.Subrubro;
      state.Locales[index].Telefono = data.Telefono;
      state.Locales[index].ShowUnidades = data.ShowUnidades;
      state.Locales[index].UnidadEmpleados = data.UnidadEmpleados;
      state.Locales[index].ID = data.ID;
    },
    removeSucursal(state,ID)
    {
      state.Locales = state.Locales.filter(sucursal => sucursal.ID !== ID);
    },
    setValidBusiness(state, payload)
    {
      state.ValidBusiness = payload;
    },
    setValidZone(state,payload)
    {
      state.ValidZone = payload;
    }
  },
  getters:
  {
    getState(state)
    {
      return state;
    },
    getDiscount(state)
    {
      return state.Discount;
    },
    getDisableAddMoreMembers(state)
    {
      return state.Locales.length === 5;
    },
    getCupon(state)
    {
      return state.Cupon;
    },
    getSteppers(state)
    {
      if(state.haveCuit === undefined)
        return [{id:"1",enable:true},{id:"2",enable:false},{id:"3",enable:false},{id:"4",enable:false}];

      if(!state.ValidBusiness)
        return [{id:"1",enable:true},{id:"2",enable:true},{id:"3",enable:false},{id:"4",enable:false}];

      if(!state.ValidZone)
        return [{id:"1",enable:true},{id:"2",enable:true},{id:"3",enable:true},{id:"4",enable:false}];

      return [{id:"1",enable:true},{id:"2",enable:true},{id:"3",enable:true},{id:"4",enable:true}];

    },
    getPayloadvalidateBusiness(state,haveCuit)
    {
      var payloadForm = new FormData();
      payloadForm.append("bussines_name", state.Institucion);

      if(haveCuit)
      {
        payloadForm.append("cuit", state.Cuit);
        payloadForm.append("afip_bussines_name", state.RazonSocial);
        payloadForm.append("cuit", state.CoindicionIVA);
      }
      else
      {
        payloadForm.append("cuit", "");
        payloadForm.append("afip_bussines_name", "");
        payloadForm.append("afip_condition", "");
      }

      payloadForm.append("own_firstname", state.Nombre);
      payloadForm.append("own_lastname", state.Apellido);
      payloadForm.append("email", state.Email);
      payloadForm.append("document_type",  getDocumentoID(state.DocumentType));
      payloadForm.append("document_number",  state.Documento);
      payloadForm.append("bussines_responsible",  state.Caracter);
      payloadForm.append("phone_code",  state.CodigoArea);
      payloadForm.append("phone_number",  state.Celular);
      payloadForm.append("phone",  `${state.CodigoArea}-${state.Celular}`);
      payloadForm.append("hascuit",  "");
     
      return payloadForm;
    },
    getPayloadvalidateZone(state)
    {
      var payloadForm = new FormData();

      payloadForm.append("coords[lat]", state.Direccion.Latitud);
      payloadForm.append("coords[lng]", state.Direccion.Longitud);

      payloadForm.append("zone", state.Direccion.Localidad.id);
      payloadForm.append("check_address", 1);
      payloadForm.append("address", state.Direccion.Calle);
      payloadForm.append("address_number", state.Direccion.Altura);
      payloadForm.append("address2", state.Direccion.Piso); 
      payloadForm.append("neighborhood", state.Direccion.Barrio);
      payloadForm.append("phone", `${state.Direccion.CodigoArea}-${state.Direccion.Celular}`);
      payloadForm.append("subcategory", state.Subrubro); 

      return payloadForm;
    },
    getPayloadMemberCookie(state)
    {
      var people = [];
      people.push({
        "lat"	:	state.Direccion.Latitud,
        "lng"	:	state.Direccion.Longitud,
        "city"	:	state.Direccion.Localidad.title,
        "zone"	:	state.Direccion.Localidad.zone,
        "phone"	:	state.CodigoArea+'-'+state.Celular,
        "price"	:	state.Precio,
        "address"	:	state.Direccion.Calle,
        "address2"	:	state.Direccion.Piso,
        "category"	:	state.Rubro.id,
        "phone_code"	:	state.CodigoArea,
        "subcategory"	:	state.Subrubro.id,
        "category_lbl"	:	state.Subrubro.title,
        /* "neighborhood"	:	Centro, */
        "phone_number"	:	state.Celular,
        "search_number"	:	state.Direccion.Altura,
        "address_number"	:	state.Direccion.Altura,
        "price_category"	:	state.RangeValue,
        "search_address"	:	state.Direccion.Altura,
        "people_quantity"	:	state.Empleados,
/*           "subcategory_lbl"	:	GARAGES, COCHERAS, ESTACIONAMIENTOS, */
/*           "subcategory_code"	:	171, */
        "people_quantity_label"	:	state.Empleados,
        "busqueda":state.Direccion.busqueda
      })
      state.Locales.map(el=>{
        people.push({
          "lat"	:	el.Direccion.Latitud,
          "lng"	:	el.Direccion.Longitud,
          "city"	:	el.Direccion.Localidad.title,
          "zone"	:	el.Direccion.Localidad.zone,
          "phone"	:	el.CodigoArea+'-'+el.Celular,
          "price"	:	el.Precio,
          "address"	:	el.Direccion.Calle,
          "address2"	:	el.Direccion.Piso,
          "category"	:	el.Rubro.id,
          "phone_code"	:	el.CodigoArea,
          "subcategory"	:	el.Subrubro.id,
          "category_lbl"	:	el.Subrubro.title,
          /* "neighborhood"	:	Centro, */
          "phone_number"	:	el.Celular,
          "search_number"	:	el.Direccion.Altura,
          "address_number"	:	el.Direccion.Altura,
          "price_category"	:	el.RangeValue,
          "search_address"	:	el.Direccion.Altura,
          "people_quantity"	:	el.Empleados,
/*           "subcategory_lbl"	:	GARAGES, COCHERAS, ESTACIONAMIENTOS, */
/*           "subcategory_code"	:	171, */
          "people_quantity_label"	:	el.Empleados


        })
      })
      const data = {"body": {
                            "total": state.Precio, 
                            "people": people,
                            "bussines": {"cuit": state.Cuit, 
                            "email": state.Email, 
                            "phone": `${state.CodigoArea}-${state.Celular}`, 
                            "hascuit": state.haveCuit, 
                            "lastname": state.Apellido, 
                            "firstname": state.Nombre, 
                            "phone_code": state.CodigoArea, 
                            "own_lastname": state.Apellido, 
                            "phone_number": state.Celular, 
                            "bussines_name": state.Institucion, 
                            "document_type": 1, 
                            "own_firstname": state.Nombre, 
                            "afip_condition": state.CoindicionIVA, 
                            "document_number": state.Documento, 
                            "afip_bussines_name": state.RazonSocial, 
                            "bussines_responsible": state.Caracter}, 
                            "response": {"msg": "", "valid": "true"}, 
                            "collect_people_data": 1,  
                          }, 
                             
                             "step": 4, 
                             "productid": 2}

            

      return data;
    },
    getCuit(state)
    {
      return state.Cuit;
    },
    getLocales(state)
    {
      return state.Locales;
    },
    getTotal(state)
    {
      const {Discount, Cupon,Precio, DescuentoCBU, DescuentoCC, PaymentMethod} = state;
      
      var InitialTotal = Precio;

      let discount_payment_method = 0; 
      const isPromotor = (VueCookies.get('codPromotor') !== null && VueCookies.get('promotorName') !== null) || state.ItsPromotor;
      if(!isPromotor) {
        state.PaymentMethod === "Debit" ? discount_payment_method = Number(state.DescuentoCBU) : discount_payment_method = Number(state.DescuentoCC);
      }
      

      if(discount_payment_method > 0)
      {
        InitialTotal = Math.ceil( InitialTotal - (InitialTotal * discount_payment_method / 100));
      }

      for (const Local of state.Locales) 
      {
        if(discount_payment_method > 0)
        {
          InitialTotal += Math.ceil( Local.Precio - (Local.Precio * discount_payment_method / 100));
        }
        else
        {
          InitialTotal += Local.Precio;
        }
        
      }
      if(Cupon) InitialTotal = Math.ceil(state.Cupon.totalWithGiftcard);
      return InitialTotal;
    },
    getSucursalesLength(state)
    {
      return state.Locales.length + 1;
    }
  }
}

export default EmpresasState;